// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : MOHAMMED YUSUF
// Last ADD : VEHICLE SEIZED ADDED
// MODFIED DATA : 23-12-2025

import AutoLoanCollectionTypes from './auto-loan-collection.types';

/** ***************** GET AUTO LOAN INDEX LIST START *********************** */
export const fetchAutoLoanIndexStart = (getData: any) => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_INDEX_LIST_START,
	payload: getData,
});

export const fetchAutoLoanIndexSuccess = (successData: any) => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_INDEX_LIST_SUCCESS,
	payload: successData,
});

export const fetchAutoLoanIndexFailure = (failureData: any) => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_INDEX_LIST_FAILURE,
	payload: failureData,
});

export const fetchAutoLoanIndexResponseReset = () => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_INDEX_LIST_RESPONSE_RESET,
});

export const fetchAutoLoanIndexResponseChanged = () => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_INDEX_LIST_RESPONSE_CHANGED,
});
/** ***************** GET AUTO LOAN INDEX  LIST END *********************** */

/** ***************** GET AUTO LOAN COLLECTION LIST START *********************** */
export const fetchAutoLoanCollectionStart = (getData: any) => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_COLLECTION_LIST_START,
	payload: getData,
});

export const fetchAutoLoanCollectionSuccess = (successData: any) => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_COLLECTION_LIST_SUCCESS,
	payload: successData,
});

export const fetchAutoLoanCollectionFailure = (failureData: any) => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_COLLECTION_LIST_FAILURE,
	payload: failureData,
});

export const fetchAutoLoanCollectionResponseReset = () => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_COLLECTION_LIST_RESPONSE_RESET,
});

export const fetchAutoLoanCollectionResponseChanged = () => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_COLLECTION_LIST_RESPONSE_CHANGED,
});
/** ***************** GET AUTO LOAN COLLECTION  LIST END *********************** */

/** ***************** UPDATE AUTO LOAN COLLECTION *********************** */
export const updatAutoLoanCollectionStart = (updateCollection: any) => ({
	type: AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_COLLECTION_START,
	payload: updateCollection,
});

export const updatAutoLoanCollectionSuccess = (successData: any) => ({
	type: AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_COLLECTION_SUCCESS,
	payload: successData,
});

export const updatAutoLoanCollectionFailure = (failureData: any) => ({
	type: AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_COLLECTION_FAILURE,
	payload: failureData,
});

export const updatAutoLoanCollectionResponseResetStart = () => ({
	type: AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_COLLECTION_RESPONSE_RESET_START,
});

export const updatAutoLoanCollectionResponseChanged = () => ({
	type: AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_COLLECTION_RESPONSE_CHANGED,
});
/** ***************** UPDATE AUTO LOAN COLLECTION *********************** */

/** ***************** REVERT AUTO LOAN COLLECTION START *********************** */
export const revertAutoLoanCollectionStart = (revertCollection: any) => ({
	type: AutoLoanCollectionTypes.REVERT_AUTO_LOAN_COLLECTION_START,
	payload: revertCollection,
});

export const revertAutoLoanCollectionSuccess = (successData: any) => ({
	type: AutoLoanCollectionTypes.REVERT_AUTO_LOAN_COLLECTION_SUCCESS,
	payload: successData,
});

export const revertAutoLoanCollectionFailure = (failureData: any) => ({
	type: AutoLoanCollectionTypes.REVERT_AUTO_LOAN_COLLECTION_FAILURE,
	payload: failureData,
});

export const revertAutoLoanCollectionResponseResetStart = () => ({
	type: AutoLoanCollectionTypes.REVERT_AUTO_LOAN_COLLECTION_RESPONSE_RESET_START,
});

export const revertAutoLoanCollectionResponseChanged = () => ({
	type: AutoLoanCollectionTypes.REVERT_AUTO_LOAN_COLLECTION_RESPONSE_CHANGED,
});
/** ***************** REVERT AUTO LOAN COLLECTION END*********************** */

/** ***************** REVERT AUTO LOAN MEMBER WALLET START *********************** */
export const revertAutoLoanMemberWalletStart = (deleteData: any) => ({
	type: AutoLoanCollectionTypes.REVERT_AUTO_LOAN_MEMBER_WALLET_START,
	payload: deleteData,
});

export const revertAutoLoanMemberWalletSucess = (successData: any) => ({
	type: AutoLoanCollectionTypes.REVERT_AUTO_LOAN_MEMBER_WALLET_SUCCESS,
	payload: successData,
});

export const revertAutoLoanMemberWalletFailure = (failureData: any) => ({
	type: AutoLoanCollectionTypes.REVERT_AUTO_LOAN_MEMBER_WALLET_FAILURE,
	payload: failureData,
});

export const revertAutoLoanMemberWalletResponseResetStart = () => ({
	type: AutoLoanCollectionTypes.REVERT_AUTO_LOAN_MEMBER_WALLET_RESPONSE_RESET_START,
});

export const revertAutoLoanMemberWalletResponseChanged = () => ({
	type: AutoLoanCollectionTypes.REVERT_AUTO_LOAN_MEMBER_WALLET_RESPONSE_CHANGED,
});
/** *****************  REVERT AUTO LOAN MEMBER WALLET END *********************** */

/** ***************** UPDATE INTEREST WAIVER START *********************** */
export const updateAutoLoanInterestWaiverStart = (getData: any) => ({
	type: AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_INTEREST_WAIVER_START,
	payload: getData,
});

export const updateAutoLoanInterestWaiverSuccess = (successData: any) => ({
	type: AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_INTEREST_WAIVER_SUCCESS,
	payload: successData,
});

export const updateAutoLoanInterestWaiverFailure = (failureData: any) => ({
	type: AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_INTEREST_WAIVER_FAILURE,
	payload: failureData,
});

export const updateAutoLoanInterestWaiverResponseResetStart = () => ({
	type: AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_INTEREST_WAIVER_RESPONSE_RESET,
});

export const updateAutoLoanInterestWaiverResponseChanged = () => ({
	type: AutoLoanCollectionTypes.UPDATE_AUTO_LOAN_INTEREST_WAIVER_RESPONSE_CHANGED,
});
/** ***************** UPDATE INTEREST WAIVER END *********************** */

/** ***************** AUTO LOAN COLLECTION APPROVAL START *********************** */
export const autoLoanCollectionApprovalStart = (getData: any) => ({
	type: AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_APPROVAL_START,
	payload: getData,
});

export const autoLoanCollectionApprovalSuccess = (successData: any) => ({
	type: AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_APPROVAL_SUCCESS,
	payload: successData,
});

export const autoLoanCollectionApprovalFailure = (failureData: any) => ({
	type: AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_APPROVAL_FAILURE,
	payload: failureData,
});

export const autoLoanCollectionApprovalResponseReset = () => ({
	type: AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_APPROVAL_RESPONSE_RESET,
});

export const autoLoanCollectionApprovalResponseChanged = () => ({
	type: AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_APPROVAL_RESPONSE_CHANGED,
});

/** ***************** AUTO LOAN COLLECTION APPROVAL END *********************** */

/** ***************** AUTO LOAN COLLECTION VEHICLE SEIZED START *********************** */
export const autoLoanCollectionVehicleSeizedStart = (getData: any) => ({
	type: AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_VEHICLE_SEIZED_START,
	payload: getData,
});

export const autoLoanCollectionVehicleSeizedSuccess = (successData: any) => ({
	type: AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_VEHICLE_SEIZED_SUCCESS,
	payload: successData,
});

export const autoLoanCollectionVehicleSeizedFailure = (failureData: any) => ({
	type: AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_VEHICLE_SEIZED_FAILURE,
	payload: failureData,
});

export const autoLoanCollectionVehicleSeizedResponseReset = () => ({
	type: AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_VEHICLE_SEIZED_RESPONSE_RESET,
});

/** *********** ADD AUTO LOAN MEMBER WALLET START ********* */
export const addAutoLoanMemberWalletStart = (data: any) => ({
	type: AutoLoanCollectionTypes.ADD_AUTO_LOAN_MEMBER_WALLET_START,
	payload: data,
});

/** *********** ADD AUTO LOAN MEMBER WALLET RESPONSE RESET START ********* */
export const addAutoLoanMemberWalletResponseResetStart = () => ({
	type: AutoLoanCollectionTypes.ADD_AUTO_LOAN_MEMBER_WALLET_RESPONSE_RESET_START,
});

export const addAutoLoanMemberWalletSuccess = (data: any) => ({
	type: AutoLoanCollectionTypes.ADD_AUTO_LOAN_MEMBER_WALLET_SUCCESS,
	payload: data,
});

export const addAutoLoanMemberWalletFailure = (data: any) => ({
	type: AutoLoanCollectionTypes.ADD_AUTO_LOAN_MEMBER_WALLET_FAILURE,
	payload: data,
});

export const addAutoLoanMemberWalletResponseChanged = () => ({
	type: AutoLoanCollectionTypes.ADD_AUTO_LOAN_MEMBER_WALLET_RESPONSE_CHANGED,
});

export const autoLoanCollectionVehicleSeizedResponseChanged = () => ({
	type: AutoLoanCollectionTypes.AUTO_LOAN_COLLECTION_VEHICLE_SEIZED_RESPONSE_CHANGED,
});

/** ***************** AUTO LOAN COLLECTION VEHICLE SEIZED END *********************** */

/** ***************** GET AUTO LOAN REPAYMENT START *********************** */

export const fetchAutoLoanRepaymentStart = (getData: any) => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_REPAYMENT_START,
	payload: getData,
});

export const fetchAutoLoanRepaymentSuccess = (successData: any) => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_REPAYMENT_SUCCESS,
	payload: successData,
});

export const fetchAutoLoanRepaymentFailure = (failureData: any) => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_REPAYMENT_FAILURE,
	payload: failureData,
});

export const fetchAutoLoanRepaymentResponseReset = () => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_REPAYMENT_RESPONSE_RESET,
});

export const fetchAutoLoanRepaymentResponseChanged = () => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_REPAYMENT_RESPONSE_CHANGED,
});

/** ***************** GET AUTO LOAN REPAYMENT END *********************** */

/** ***************** GET AUTO LOAN ARREAR COLLECTIONS START *********************** */
export const fetchAutoLoanArrearCollectionsStart = (getData: any) => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_START,
	payload: getData,
});

export const fetchAutoLoanArrearCollectionsSuccess = (successData: any) => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_SUCCESS,
	payload: successData,
});

export const fetchAutoLoanArrearCollectionsFailure = (failureData: any) => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_FAILURE,
	payload: failureData,
});

export const fetchAutoLoanArrearCollectionsResponseReset = () => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_RESPONSE_RESET,
});

export const fetchAutoLoanArrearCollectionsResponseChanged = () => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_RESPONSE_CHANGED,
});
/** ***************** GET AUTO LOAN ARREAR COLLECTIONS END *********************** */

/** ***************** GET AUTO LOAN VEHICLE DETAILS START *********************** */
export const fetchAutoLoanVehicleDetailsStart = (getData: any) => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_VEHICLE_DETAILS_START,
	payload: getData,
});

export const fetchAutoLoanVehicleDetailsSuccess = (successData: any) => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_VEHICLE_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchAutoLoanVehicleDetailsFailure = (failureData: any) => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_VEHICLE_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchAutoLoanVehicleDetailsResponseReset = () => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_VEHICLE_DETAILS_RESPONSE_RESET,
});

export const fetchAutoLoanVehicleDetailsResponseChanged = () => ({
	type: AutoLoanCollectionTypes.FETCH_AUTO_LOAN_VEHICLE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET AUTO LOAN VEHICLE DETAILS END *********************** */
